import { Component } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';
import { SkeletonHandoffDirective } from '../../../directives/skeleton-handoff.directive';
import { AtlasGridSkeletonComponent } from '../atlas-grid-skeleton/atlas-grid-skeleton.component';

/**
 * Loading placeholder for an opened report (story): mirrors the fullscreen
 * galleria of `StoryGalleryComponent` - caption bar, widget grid of the
 * first slide, slide navigators and indicator strip.
 */
@Component({
  selector: 'app-atlas-story-skeleton',
  standalone: true,
  hostDirectives: [SkeletonHandoffDirective],
  imports: [SkeletonModule, AtlasGridSkeletonComponent],
  templateUrl: './atlas-story-skeleton.component.html',
  styleUrl: './atlas-story-skeleton.component.scss',
})
export class AtlasStorySkeletonComponent {
  readonly indicators = [0, 1, 2, 3];
}
